import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/dressUpBook',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-dressUpBook-index" */ '~/pages/DressUpBook/pages/index'
        )
    ),
  },
  // 标题勋章
  {
    path: '/dressUpBook/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-dressUpBook-rank" */ '~/pages/DressUpBook/pages/rank'
        )
    ),
  },
  {
    path: '/dressUpBook/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-dressUpBook-rule" */ '~/pages/DressUpBook/pages/rule'
        )
    ),
  },
  {
    path: '/dressUpBook/level',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-dressUpBook-rule" */ '~/pages/DressUpBook/pages/level'
        )
    ),
  },
] as RouteConfig[]
